var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-active-ring-chart',{staticStyle:{"width":"300px","height":"250px"},attrs:{"config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }